import AttachEmailOutlinedIcon from "@mui/icons-material/AttachEmailOutlined"
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Divider from "@mui/material/Divider"
import Typography from "@mui/material/Typography"
import { capitalize } from "lodash"
import { useNavigate } from "react-router-dom"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { formatDate } from "../../../common/utils"
import { trimLongString } from "../../../common/utils"
import CandidateAvatar from "../components/CandidateAvatar"
import DialogHeader from "../components/DialogHeader"
import RatingStars from "./RatingStars"
import { getCandidateTypeLabel } from "./candidateType"
import { navigateToCandidateDetails } from "./navigation"

export default function CandidatePartialDetailsMobileDialog({
  candidate,
  open,
  onClose,
  listNavigationState,
}) {
  const navigate = useNavigate()

  function handleMoreDetailsButtonClicked() {
    onClose()
    if (listNavigationState) {
      navigateToCandidateDetails(
        navigate,
        listNavigationState.candidatesListSearch,
        listNavigationState.listContext,
        candidate.id
      )
      return
    }
    navigate(`/candidates/${candidate.id}`)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogHeader title="" onClose={onClose} />
      <DialogContent>
        <Column>
          <CandidateAvatar candidate={candidate} size="64px" fontSize="24px" />
          <Typography variant="h4" sx={{ mt: 2 }}>
            {candidate.candidate_name}
          </Typography>
          <Column sx={{ mt: 2, gap: 1 }}>
            <IconText Icon={AttachEmailOutlinedIcon} text={candidate.email} />
            <IconText Icon={PhoneOutlinedIcon} text={candidate.phone} />
          </Column>
        </Column>
        <Divider sx={{ my: 2 }} />
        <Column sx={{ gap: 1 }}>
          <TitledSomething title="Appointment Date">
            <Typography variant="body1" color="text.secondary">
              {formatDate(candidate.stamp)}
            </Typography>
          </TitledSomething>
          <TitledSomething title="Company Name">
            <Typography variant="body1" color="text.secondary">
              {candidate.company_name || "--"}
            </Typography>
          </TitledSomething>
          <TitledSomething title="Rating">
            <RatingStars candidate={candidate} width="16px" />
          </TitledSomething>
          <TitledSomething title="Type">
            <Typography variant="body1" color="text.secondary">
              {getCandidateTypeLabel(candidate) || "--"}
            </Typography>
          </TitledSomething>
          <TitledSomething title="Stage">
            <Typography variant="body1" color="text.secondary">
              {capitalize(candidate.stage || "--")}
            </Typography>
          </TitledSomething>
          <TitledSomething title="Notes">
            <Typography variant="body1" color="text.secondary">
              {candidate.notes ? trimLongString(candidate.notes, 30) : "--"}
            </Typography>
          </TitledSomething>
        </Column>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3 }}
          onClick={handleMoreDetailsButtonClicked}
        >
          View More Details
        </Button>
      </DialogContent>
    </Dialog>
  )
}

function IconText({ Icon, text }) {
  return (
    <Row sx={{ alignItems: "center", gap: 1 }}>
      <Icon sx={{ width: "16px", color: "#9525D6" }} />
      <Typography variant="body1" color="text.secondary">
        {text}
      </Typography>
    </Row>
  )
}

function TitledSomething({ title, children }) {
  return (
    <Row sx={{ gap: 1 }}>
      <Typography variant="h6" fontWeight={600}>
        {title}
      </Typography>
      {children}
    </Row>
  )
}
